import * as constants from './../constants';
import { API_AUTH_SERVICE_PORT } from '../../config/env/env';
import { sourceSystems } from '../../utils/constants';
import { showMessage, generateShadowEndpoint } from '../../utils/helper';
import store from '../../store/configureStore';

/**
 * Send OTP API Call - Login
 * @param {*} data
 * @param {*} onSuccess
 * @param {*} onError
 * @returns
 */
export const sendOTP = (phoneNumber, countryCode, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/auth/sendOtp/${encodeURIComponent(phoneNumber)}?source=StaffPay&loginFrom=desktop&countryCode=${encodeURIComponent(countryCode)}`,
        method: 'GET',
        data: { phoneNumber, countryCode },
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_AUTH_SERVICE_PORT,
    },
});

/**
 * OTP-on-call API call - Login. Generates the OTP and returns the inbound DID
 * (`otpOnCallMobileNumber`) the user should call to receive it. Used as an
 * alternate delivery channel when the SMS OTP does not arrive.
 *
 * Relative URL, so the middleware prefixes the per-env API_URL - same as
 * sendOTP, including the `source` and `countryCode` query params.
 * @param {string} phoneNumber
 * @param {string} countryCode
 * @param {(resp: any) => void} onSuccess
 * @param {(err: any) => void} onError
 * @returns
 */
export const sendOTPViaCall = (
    phoneNumber,
    countryCode,
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: `/auth/otp/${encodeURIComponent(phoneNumber)}?source=StaffPay&loginFrom=desktop&countryCode=${encodeURIComponent(countryCode)}`,
        method: 'GET',
        success: () => ({ type: constants.DO_NOTHING }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_AUTH_SERVICE_PORT,
    },
});

/**
 * Validate OTP API call - on successful response, persist the user info in local storage and redux store
 * @param {*} data
 * @param {*} onSuccess
 * @param {*} onError
 * @returns
 */
export const validateOTP = (
    { overwriteHeaders, ...data },
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: '/auth/login',
        method: 'POST',
        data,
        success: (response) => setUserInfo(response),
        // success: (response) => {
        //     return { type: constants.DO_NOTHING, payload: response };
        // },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_AUTH_SERVICE_PORT,
        overwriteHeaders,
    },
});

export const refreshToken = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/auth/refresh-login',
        method: 'GET',
        success: (response) => setUserInfo(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_AUTH_SERVICE_PORT,
    },
});

/*
 * ── MPIN (second factor) — self-scoped endpoints ─────────────────────────
 * All four ride the OTP-issued JWT. `hideNotify: true` everywhere: MPIN
 * errors render inline on the /mpin page, anchored to the field they
 * belong to — the global snackbar must stay silent. Raw MPIN values pass
 * through request bodies only; never log or store them.
 */

/** Launch/resume-time state resolution (unprefixed counter names). */
export const getMpinStatus = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/user/mpin/status',
        method: 'GET',
        hideNotify: true,
        success: () => ({ type: constants.DO_NOTHING }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

/** First-time setup / after an admin expire. Must NOT send oldMpin. */
export const setupMpin = ({ mpin, confirmMpin }, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/user/mpin/setup',
        method: 'POST',
        data: { mpin, confirmMpin },
        hideNotify: true,
        success: () => ({ type: constants.DO_NOTHING }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

/** Everyday second factor. Failures carry attemptsRemaining / lockout. */
export const verifyMpin = ({ mpin }, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/user/mpin/verify',
        method: 'POST',
        data: { mpin },
        hideNotify: true,
        success: () => ({ type: constants.DO_NOTHING }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

/** 90-day rotation: old → new → confirm. Shares the lockout with verify. */
export const changeMpin = (
    { oldMpin, newMpin, confirmMpin },
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: '/user/mpin/change',
        method: 'POST',
        data: { oldMpin, newMpin, confirmMpin },
        hideNotify: true,
        success: () => ({ type: constants.DO_NOTHING }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

/**
 * On Valiate OTP success, we parse the response data and persist user info in local storage
 * @param {*} data
 * @param {*} loginFromWeb
 * @returns
 */
export const setUserInfo = (data) => {
    console.log('AuthActionCreator', 'the data is', data);
    let userInfo = {
        id: null,
        name: null,
        orgId: null,
        contactNumber: null,
    };

    // Response to have status 200 for all success cases
    if (data && data.status && data.status.code === 200) {
        if (
            data &&
            data.response &&
            data.response.token &&
            data.response.userBO
        ) {
            userInfo = {
                ...data.response.userBO,
                token: data.response.token,
            };
            console.log('login info', userInfo, window);
            console.log('login info2', window);
            localStorage.setItem(
                'USER_INFO',
                window.btoa(
                    unescape(encodeURIComponent(JSON.stringify(userInfo))),
                ),
            );
        }
        return { type: constants.SET_USER_INFO, payload: userInfo };
    }
    return { type: constants.SET_USER_INFO, payload: userInfo };
};

export const fetchAppConfig = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/common/configs`,
        method: 'GET',
        // success: response => {
        //     return {
        //         type: constants.SET_CONFIG,
        //         payload: response.response,
        //     };
        // },
        success: (response) => setConfigInfo(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_AUTH_SERVICE_PORT,
    },
});

const setConfigInfo = (data, loginFromWeb) => {
    // logger.log('AuthActionCreator', 'the data is', data);
    let configInfo = {};

    console.log('DATAAAAAA:', data);

    // Response to have status 200 for all success cases
    if (data && data.status && data.status.code === 200) {
        if (data && data.response && data.response.configs) {
            configInfo = {
                ...data.response.configs,
            };

            console.log('VALLL', configInfo);
            // localStorage.setItem(
            //     'CONFIGS',
            //     window.btoa(JSON.stringify(configInfo)),
            // );

            // AsyncStorage.setItem("USER_INFO", JSON.stringify(userInfo));
        }
    }
    return { type: constants.SET_CONFIG, payload: configInfo };
};

/**
 * Fetch the consent declaration content shown to BlueDart users post-login.
 * Returns paragraphs with `{{placeholder}}` tokens to be interpolated client-side.
 * @param {{ number: string, source?: string }} params
 * @param {(resp: any) => void} onSuccess
 * @param {(err: any) => void} onError
 */
export const checkSsoEligible = (contactNumber, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/auth/sso/eligible/${encodeURIComponent(contactNumber)}`,
        method: 'GET',
        hideNotify: true,
        success: () => ({ type: constants.DO_NOTHING }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_AUTH_SERVICE_PORT,
    },
});

export const getConsentContent = (
    { number, source = 'desktop' },
    onSuccess,
    onError,
) => ({
    type: constants.API,
    thirdParty: false,
    payload: {
        url: `/auth/consent/content?contactNumber=${encodeURIComponent(
            number,
        )}&source=${source}`,
        method: 'GET',
        success: () => ({ type: constants.DO_NOTHING }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_AUTH_SERVICE_PORT,
    },
});

export const checkBluedartConsentMissing = (userId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/user/${userId}/bluedart-consent-missing`,
        method: 'GET',
        success: () => ({ type: constants.DO_NOTHING }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const setBluedartConsent = (userId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/user/${userId}/bluedart-consent?value=true`,
        method: 'POST',
        success: () => ({ type: constants.DO_NOTHING }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const getSourceSystemsList = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        source: sourceSystems.Zappay,
        url: `/org/source-systems`,
        method: 'GET',
        success: (response) => {
            return {
                type: constants.SET_SOURCE_SYSTEMS_LIST_DATA,
                payload: response?.response?.sourceSystems,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const getSourceSystemsFiltersListData = (data, onSuccess, onError) => {
    let queryParams = '';
    if (data?.startTimeEpochMillis && data?.endTimeEpochMillis) {
        queryParams = `?startEpochMillis=${data.startTimeEpochMillis}&endEpochMillis=${data.endTimeEpochMillis}`;
    }

    return {
        type: constants.API,
        payload: {
            source: sourceSystems.Zappay,
            url: `/org/source-system/${data?.id}/filters${queryParams}`,
            method: 'GET',
            success: (response) => {
                return {
                    type: constants.SET_SOURCE_SYSTEMS_FILTER_LIST_DATA,
                    payload: response?.response?.filters,
                };
            },
            postProcessSuccess: onSuccess,
            postProcessError: onError,
        },
    };
};

export const getPaymentBroker = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        source: sourceSystems.Zappay,
        url: `/org/source-system/${data?.id}/payment-broker`,
        method: 'GET',
        success: (response) => {
            return {
                type: constants.SET_PAYMENT_BROKER,
                payload: response?.response?.activeBroker,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const updatePaymentBroker = ({ id, broker }, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        source: sourceSystems.Zappay,
        url: `/org/source-system/${id}/payment-broker`,
        method: 'PUT',
        data: { broker },
        success: (response) => {
            return {
                type: constants.SET_PAYMENT_BROKER,
                payload: response?.response?.activeBroker,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const getAxisBankBalance = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        source: sourceSystems.Zappay,
        url: `/user/axis-balance`,
        method: 'GET',
        success: (response) => {
            return {
                type: constants.SET_AXIS_BANK_BALANCE,
                payload: response?.response,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const uploadPaymentIndents = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        source: sourceSystems.Zappay,
        url: `/user/payment-indents/upload`,
        method: 'POST',
        data: data,
        success: (response) => {
            return {
                type: constants.DO_NOTHING,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const getAllPaymentIndentsListingData = (data, onSuccess, onError) => {
    const hasFilters = data?.filters && Object.keys(data?.filters).length > 0;
    const hasValidDateRange =
        !!data?.dateRange?.startTimeEpochMillis &&
        !!data?.dateRange?.endTimeEpochMillis;

    if (!hasValidDateRange && !hasFilters) {
        const errorMessage = 'Date range is required to fetch payment indents';
        showMessage(errorMessage, 'error');
        onError && onError({ message: errorMessage });
        return { type: constants.DO_NOTHING };
    }

    // Mirror the same request to the shadowIP in parallel (fire-and-forget).
    // It does NOT update any data and stays silent - purely a shadow call
    // alongside the original.
    mirrorPaymentIndentsToShadow(data);

    return {
        type: constants.API,
        payload: {
            source: sourceSystems.Zappay,
            url: `/user/payment-indents`,
            method: 'POST',
            data: data,
            success: (response) => {
                return {
                    type: constants.SET_ALL_PAYMENT_INDENTS_LIST_DATA,
                    payload: response?.response,
                };
            },
            postProcessSuccess: onSuccess,
            postProcessError: onError,
        },
    };
};

/**
 * Fires the payment-indents request against the shadowIP in parallel with the
 * original call. Does nothing with the response (no reducer update, no
 * callbacks) and suppresses notifications - it is a pure shadow/mirror call.
 * No-op when no shadowIP is configured.
 * @param {*} data
 */
const mirrorPaymentIndentsToShadow = (data) => {
    const shadowEndpoint = generateShadowEndpoint('/user/payment-indents');
    if (!shadowEndpoint) return;

    store.dispatch({
        type: constants.API,
        payload: {
            ...shadowEndpoint,
            method: 'POST',
            data: data,
            hideNotify: true,
            success: () => ({ type: constants.DO_NOTHING }),
        },
    });
};

export const setFilterModalConfig = (data, onSuccess, onError) => {
    console.log('setFilterModalConfig:', data);
    return { type: constants.SET_FILTER_MODAL_CONFIG, payload: data };
};

export const setBulkReleaseFlag = (data) => {
    return { type: constants.SET_BULK_RELEASE, payload: data };
};

export const setSelectedPayments = (data) => {
    return {
        type: constants.SET_SELECTED_PAYMENTS,
        payload: data,
    };
};

export const getAllContactsListingData = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        source: sourceSystems.Zappay,
        url: `/user/beneficiaries`,
        method: 'GET',
        success: (response) => {
            return {
                type: constants.SET_ALL_BENEFICIARIES_LIST_DATA,
                payload: response?.response,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const setIgnoreDateFilter = (data, onSuccess, onError) => {
    console.log('setIgnoreDateFilter:', data);
    return { type: constants.SET_IGNORE_DATE_FILTER_FLAG, payload: data };
};

// ====================== ZAPPAY PAYMENTS

export const sendSinglePayment = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        source: sourceSystems.Zappay,
        url: `/user/payment`,
        method: 'POST',
        data: data,
        success: (response) => {
            return {
                type: constants.DO_NOTHING,
                // payload: response?.response,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const sendBatchPayment = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        source: sourceSystems.Zappay,
        url: `/user/payment/batch`,
        method: 'POST',
        data: data,
        success: (response) => {
            return {
                type: constants.DO_NOTHING,
                // payload: response?.response,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const deleteSinglePayment = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        source: sourceSystems.Zappay,
        url: `/user/payment-indent/${data}`,
        method: 'DELETE',
        success: (response) => {
            return {
                type: constants.DO_NOTHING,
                // payload: response?.response,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const deleteBatchPayment = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        source: sourceSystems.Zappay,
        url: `/user/payment-indents`,
        method: 'DELETE',
        data: data,
        success: (response) => {
            return {
                type: constants.DO_NOTHING,
                // payload: response?.response,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const updatePaymentStatus = ({ id, data }, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        source: sourceSystems.Zappay,
        url: `/user/payment-indent/${id}/status`,
        method: 'PUT',
        data: data,
        success: (response) => {
            return {
                type: constants.DO_NOTHING,
                // payload: response?.response,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const uploadRemittance = (data, onSuccess, onError) => {
    const formData = new FormData();
    formData.append('remittance_file', data);
    return {
        type: constants.API,
        payload: {
            source: sourceSystems.Zappay,
            url: `/remittance/upload-csv`,
            method: 'POST',
            data: formData,
            success: (response) => {
                return {
                    type: constants.DO_NOTHING,
                };
            },
            postProcessSuccess: onSuccess,
            postProcessError: onError,
        },
    };
};

export const getRemittanceFiles = (status, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        source: sourceSystems.Zappay,
        url: `/remittance/files?status=${status}`,
        method: 'GET',
        success: (response) => ({ type: constants.DO_NOTHING }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const submitUtr = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        source: sourceSystems.Zappay,
        url: `/remittance/submit-utr`,
        method: 'POST',
        data: data,
        success: (response) => ({ type: constants.DO_NOTHING }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

/**
 * Reruns the rate rule engine for a user/location over a date range.
 * `actorId` is derived server-side from the caller's JWT, so it is not sent here.
 * @param {{ userIds: number[], locationIds: number[], startDateYYYYMMDD: string, endDateYYYYMMDD: string }} data
 * @param {*} onSuccess
 * @param {*} onError
 * @returns
 */
export const rerunDateRangeRule = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/rule/rate/daterange/user`,
        method: 'POST',
        data: data,
        success: (response) => ({ type: constants.DO_NOTHING }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

/**
 * Reruns the weekly rate rule engine for a user/location, anchored on the
 * last day of the target week. `actorId` is derived server-side from the
 * caller's JWT, so it is not sent here.
 * @param {{ userIds: number[], locationIds: number[], weekLastDayYYYYMMDD: string, remarks?: string }} data
 * @param {*} onSuccess
 * @param {*} onError
 * @returns
 */
export const rerunWeeklyRule = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/rule/rate/weekly/user`,
        method: 'POST',
        data: data,
        success: (response) => ({ type: constants.DO_NOTHING }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

/**
 * Fetches the full history of user-level rerun requests (most recent first).
 * No query params — the backend returns every log row.
 * @param {*} onSuccess
 * @param {*} onError
 * @returns
 */
export const getRerunHistory = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/rule/rate/daterange/user/history`,
        method: 'GET',
        success: (response) => ({ type: constants.DO_NOTHING }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});
